import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

// Updated styles to approximate the screenshot's look & feel
const skioStyles = css`
  :host {
    width: 100%;
    display: block;
  }

  /* GLOBAL RESET / BASE */
  * {
    box-sizing: border-box;
  }
  
  fieldset {
    border: none;
    padding: 0;
    margin: 0;
  }
  
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 9px;
    width: 100%;
    margin-top: 1rem;
  }
  
  .skio-choice {
    display: flex;
    flex-direction: column;
    padding: 9px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    background-color: #fff;
  }

  /* Hover / Selected States */
  .skio-choice:hover {
    background-color: #f9f9f9;
  }
  .skio-choice--selected {
    background-color: #F4F4F4;
  }
  
  /* RADIO INPUT */
  .skio-choice input[type='radio'] {
    position: absolute;
    top: 1rem;
    left: 1rem;
    width: 20px;
    height: 20px;
    margin: 0;
    opacity: 0; /* hide native radio */
    cursor: pointer;
  }
  .skio-radio-fake {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border: 1px solid #999;
    border-radius: 50%;
    margin-right: 8px;
    position: relative;
    flex-shrink: 0;
  }
  .skio-choice--selected .skio-radio-fake {
    border-color: #242424;
  }
  .skio-radio-fake::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    top: 4px;
    left: 4px;
    border-radius: 50%;
    background: transparent;
  }
  .skio-choice--selected .skio-radio-fake::after {
    background: #242424;
  }
  
  /* TOPLINE */
  .skio-topline {
    display: flex;
    align-items: center;
    gap: 0;
  }
  .skio-topline h3 {
    margin: 0;
    font-size: 14px;
    text-transform: none;
    font-weight: 400;
  }
  .skio-topline .skio-price {
    margin-left: auto;
    font-size: 18px;
    font-family: 'Pluto Cond Bold', sans-serif;
  }
  .skio-price--highlight {
    color: #F21F1F;
  }
  .skio-price--old {
    font-size: 14px;
    text-decoration: line-through;
    color: #878585;
    margin-left: 0.5rem;
    font-family: 'Pluto Cond Regular', sans-serif;
  }
  
  /* FREQUENCY DROPDOWN */
  .skio-frequency-line {
    display: flex;
    align-items: center;
    gap: 0;
    margin: 6px 0;
  }
  .skio-frequency-line label {
    font-family: 'Pluto Cond Regular', sans-serif;
    font-size: 14px;
  }
  .skio-frequency {
    flex-shrink: 0;
    border: 1px solid #cfd3d3;
    border-radius: 5px;
    background-color: #f1f2f2;
    font-size: 14px;
    padding: 4px 8px;
    appearance: none;
    cursor: pointer;
    background-image: url("//cdn.shopify.com/s/files/1/2236/0863/files/arrow-down-sign-to-navigate.png?v=1701782542");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 13px;
    width: 100%;
    min-height: 35px;
  }
  
  /* SUBSCRIPTION BENEFITS */
  .skio-benefits-list {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0 0;
    font-size: 14px;
    color: #5d5d5d;
    line-height: 1.4;
  }
  .skio-benefits-list li {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }
  .skio-benefits-list .checkmark {
    color: #8ea262;
    font-size: 18px;
    margin-right: 0.5rem;
  }
  
  /* MAKE MOBILE-FRIENDLY */
  @media (max-width: 480px) {
    .skio-frequency-line {
      flex-direction: column;
      align-items: flex-start;
    }
    .skio-frequency-line label {
      margin-bottom: 0.25rem;
    }
  }

    @media(min-width: 768px) {
    .skio-choice {
      padding: 1rem 1.5rem;
    }
    
    .skio-choice h3 {
      font-size: 18px;
    }

    .skio-topline {
      gap: 0.5rem;
    }

    .skio-radio-fake {
      margin-right: 0.75rem;
    }
    
    .skio-benefits-list li {
      margin-bottom: 4px;
      color: #242424;
      font-size: 16px;
    }

    .skio-frequency-line {
      margin: 0.75rem 0;
    }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },
    key: { type: String },
    formId: { type: String },
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},
    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},
    startSubscription: { type: Boolean },
    subscriptionFirst: { type: Boolean },
    subscriptionThird: { type: Boolean },
    discount_format: { type: String },
    ajaxSubmit: { type: Boolean },
    moneyFormatter: {},
    buttonSelector: { type: String },
    tags: { type: String },
    specialOffer: { type: Boolean },
    conditionalApply: { type: Boolean },
    benefitVariant: { type: String } // NEW: 'default' or 'frother'
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;
    this.productHandle = null;
    this.key = null;
    this.formId = null;
    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;
    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;
    this.startSubscription = true;
    this.subscriptionFirst = false;
    this.subscriptionThird = false;
    this.skioMainProduct = true;
    this.discountFormat = 'percent';
    this.ajaxSubmit = false;
    this.buttonSelector = null;
    this.benefitVariant = 'default'; // Default variant

    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window?.Shopify?.currency?.active || 'USD'
    });

    this.tags = null;
  }

  connectedCallback() {
    super.connectedCallback();
    
    // Auto-detect which variant to use based on product ID
    if (this.product && this.product.id) {
      const productId = parseInt(this.product.id);
      const frotherProductIds = [1765222776898, 8448802128060, 8448801046716];
      
      if (frotherProductIds.includes(productId)) {
        this.benefitVariant = 'frother';
      }
    }
  }

  render() {
    // If no product or variant, skip rendering entirely
    if (!this.product || !this.selectedVariant) return html``;

    // Determine if subscription selling plans are available.
    const subscriptionAvailable = this.availableSellingPlanGroups?.length > 0;

    // Get the appropriate subscription plan and discount info
    const defaultGroup = subscriptionAvailable ? this.availableSellingPlanGroups[0] : null;
    const defaultSubscriptionPlan = defaultGroup ? defaultGroup.selling_plans[0] : null;
    const subscriptionPrice = defaultSubscriptionPlan
      ? this.price(defaultSubscriptionPlan)
      : this.money(this.selectedVariant.price);
    const subscriptionDiscount = defaultSubscriptionPlan
      ? this.discount(defaultSubscriptionPlan)
      : { percent: '0%', amount: 0 };

    // Determine if one-time is selected vs. subscription.
    const oneTimeChecked = !this.selectedSellingPlanGroup;
    const subChecked = !!this.selectedSellingPlanGroup;

    // Compute the one-time price
    const oneTimePrice = this.moneyFormatter.format(this.selectedVariant.price / 100);

    // Get the currently selected discount for benefits display
    const currentDiscount = this.selectedSellingPlan 
      ? this.discount(this.selectedSellingPlan)
      : subscriptionDiscount;

    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }" skio-auto-init>
        <!-- Hidden fields: used by Shopify for subscription selection -->
        <input name="selling_plan" type="hidden"
               value="${ this.selectedSellingPlan ? this.selectedSellingPlan.id : '' }" />
        <input name="properties[Discount]" type="hidden"
               value="${ this.selectedSellingPlan ? this.discount(this.selectedSellingPlan).percent : '' }" 
               ?disabled="${ this.selectedSellingPlan == null }" />

        <!-- ONE-TIME PURCHASE CHOICE -->
        <div class="skio-choice ${oneTimeChecked ? 'skio-choice--selected' : ''}"
             @click="${() => this.selectSellingPlanGroup(null)}">
          <input
            id="skio-one-time-${ this.key }"
            class="skio-group-input"
            name="skio-group-${ this.key }"
            type="radio"
            value=""
            .checked="${oneTimeChecked}"
          >
          <div class="skio-topline">
            <!-- Fake radio for visual styling -->
            <div class="skio-radio-fake"></div>
            
            <h3>One-Time Purchase</h3>
            <div class="skio-price">${oneTimePrice}</div>
          </div>
        </div>

        <!-- SUBSCRIPTION CHOICE (only if subscription is available) -->
        ${ subscriptionAvailable ? html`
          <div class="skio-choice ${subChecked ? 'skio-choice--selected' : ''}"
               @click="${() => this.selectSellingPlanGroup(defaultGroup)}">
            <input
              id="skio-subscribe-${ this.key }"
              class="skio-group-input"
              name="skio-group-${ this.key }"
              type="radio"
              value="${ defaultGroup?.id }"
              .checked="${subChecked}"
            >
            <div class="skio-topline">
              <div class="skio-radio-fake"></div>

              <h3>
                Subscribe &amp; save${subscriptionDiscount.percent !== '0%' ? ` ${subscriptionDiscount.percent}` : ''}
              </h3>
              <div class="skio-price skio-price--highlight">
                <!-- Always show the static subscription price -->
                ${subscriptionPrice}
                <!-- compare-at / old price -->
                <span class="skio-price--old">
                  ${oneTimePrice}
                </span>
              </div>
            </div>

            <!-- FREQUENCY SELECTOR -->
            <!-- only show if user has actually chosen subscription -->
            ${ subChecked ? html`
              <div class="skio-frequency-line">
                <label for="skio-frequency-select-${ this.key }"></label>
                <select class="skio-frequency" 
                        id="skio-frequency-select-${ this.key }"
                        @change="${(e) => this.selectSellingPlan(e.target, this.selectedSellingPlanGroup)}">
                  ${ this.selectedSellingPlanGroup?.selling_plans.map((plan) => html`
                    <option 
                      value="${plan.id}"
                      ?selected="${this.selectedSellingPlan?.id === plan.id}">
                      ${plan.name}
                    </option>
                  `)}
                </select>
              </div>

              <!-- SUBSCRIPTION BENEFITS (visible when subscription is selected) -->
              <ul class="skio-benefits-list">
                <li><span class="checkmark">✓</span>${currentDiscount.percent} OFF the regular price forever</li>
                ${this.benefitVariant === 'frother' ? html`
                  <li><span class="checkmark">✓</span>1x FREE KOS Handheld Mixer Frother</li>
                ` : null}
                <li><span class="checkmark">✓</span>Access to special offers</li>
                <li><span class="checkmark">✓</span>Pause or cancel anytime</li>
              </ul>
            ` : null }
          </div>
        ` : null }
      </fieldset>
    `;
  }

  updated(changed) {
    // Re-run standard logic from your original code
    if(changed.has('product') && this.product) {
      this.key = this.product.id;
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        spg => spg.app_id === 'SKIO'
      );
      
      // Auto-detect variant based on product ID
      const productId = parseInt(this.product.id);
      const frotherProductIds = [1765222776898, 8448802128060, 8448801046716];
      
      if (frotherProductIds.includes(productId)) {
        this.benefitVariant = 'frother';
      }
    }
    if(changed.has('selectedVariant') && this.selectedVariant) {
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(
        spg => spg.selling_plans.some(sp => 
          this.selectedVariant.selling_plan_allocations.some(
            spa => spa.selling_plan_id === sp.id
          )
        )
      );
      if (this.availableSellingPlanGroups.length > 0) {
        this.availableSellingPlanGroups.forEach(g => {
          g.selected_selling_plan = g.selling_plans[0];
        });
        if (this.startSubscription || this.product.requires_selling_plan) {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
          this.selectedSellingPlan = this.selectedSellingPlanGroup.selling_plans[0];
        }
      }
    }
    if (changed.has('selectedSellingPlan')) {
      this.updateForm();
      // Dispatch a custom event if needed
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlan: this.selectedSellingPlan,
          salePrice: this.price(this.selectedSellingPlan),
          regularPrice: this.money(this.selectedVariant.price),
          showSalePrice: this.selectedSellingPlan !== null,
        }
      });
      this.dispatchEvent(event);
    }
  }

  // Called when user clicks a choice (subscription or one-time)
  selectSellingPlanGroup(group) {
    if (group == null) {
      // one-time
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
    } else {
      // subscription
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = group.selected_selling_plan || group.selling_plans[0];
    }
  }

  // Called when the user changes the frequency dropdown
  selectSellingPlan(selectElem, group) {
    let newPlan = group.selling_plans.find(x => x.id == selectElem.value);
    if (newPlan) {
      group.selected_selling_plan = newPlan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = newPlan;
    }
  }

  // Utility to format cents to currency
  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  // Returns { percent, amount } discount object for the given selling plan
  discount(selling_plan) {
    if (!selling_plan) return { percent: '0%', amount: 0 };
    const price = this.selectedVariant.price;
    const price_adjustment = selling_plan.price_adjustments[0];
    const isPrepaid = selling_plan.name.toLowerCase().includes('prepaid');
    let discount = { percent: '0%', amount: 0 };

    if (!price_adjustment) return discount; // safety check
    
    switch (price_adjustment.value_type) {
      case 'percentage': {
        discount.percent = `${price_adjustment.value}%`;
        discount.amount = Math.round((price * price_adjustment.value) / 100.0);
        break;
      }
      case 'fixed_amount': {
        discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`;
        discount.amount = price_adjustment.value;
        break;
      }
      case 'price': {
        const adjustedPrice = isPrepaid 
          ? price_adjustment.value / parseFloat(selling_plan.name)
          : price_adjustment.value;
        discount.percent = `${Math.round(((price - adjustedPrice) / price) * 100.0)}%`;
        discount.amount = price - adjustedPrice;
        break;
      }
    }
    return discount;
  }

  // Returns the final discounted price for a given selling plan
  price(selling_plan, formatted = true) {
    if (!selling_plan) return this.money(this.selectedVariant.price);

    const discountVal = this.discount(selling_plan).amount;
    const newPrice = this.selectedVariant.price - discountVal;
    return formatted ? this.money(newPrice) : newPrice;
  }

  // Sync the hidden inputs in the main form
  updateForm() {
    if (!this.formId) return;

    let form = document.querySelector(`#${this.formId}`);
    if (!form) {
      console.log(`Skio error: form ID is ${this.formId}, but no form with that ID was found.`);
      return;
    }

    let selling_plan_input = form.querySelector('[name="selling_plan"]');
    if (!selling_plan_input) {
      selling_plan_input = document.createElement('input');
      selling_plan_input.type = "hidden";
      selling_plan_input.name = "selling_plan";
      form.append(selling_plan_input);
    }
    selling_plan_input.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';

    let discount_input = form.querySelector('[name="properties[Discount]"]');
    if (!discount_input) {
      discount_input = document.createElement('input');
      discount_input.type = "hidden";
      discount_input.name = "properties[Discount]";
      form.append(discount_input);
    }
    discount_input.value = this.selectedSellingPlan ? this.discount(this.selectedSellingPlan).percent : '';
    discount_input.disabled = !this.selectedSellingPlan;
  }
}

// Register the custom element
customElements.define('skio-plan-picker', SkioPlanPickerComponent);